function view (path) {
  return () => import(/* webpackChunkName: 'asm-v2' */ '@/views/asm/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RASManager = [
  {
    path: '/asm/dashboard',
    component: view('dashboard/Base'),
    name: 'asm.dashboard'
  },
  {
    path: '/asm/customers',
    component: view('Customers'),
    name: 'asm.customers',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/customers/:customer?/managements',
    component: view('customer-management/Base'),
    name: 'asm.customers.profile',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'Customers',
          to: {
            name: 'asm.customers'
          }
        },
        {
          text: 'Customer Profile',
          active: true
        }
      ]
    }
  },
  // {
  //   path: '/asm/leads',
  //   component: view('Leads'),
  //   name: 'asm.leads',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'ASM',
  //         to: {
  //           name: 'asm.dashboard'
  //         }
  //       },
  //       {
  //         text: 'Leads',
  //         active: true
  //       }
  //     ]
  //   }
  // },
  {
    path: '/asm/leads/:lead?/managements',
    component: view('lead-management/Base'),
    name: 'asm.leads.profile',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'Leads',
          to: {
            name: 'asm.leads'
          }
        },
        {
          text: 'Lead Profile',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/officers',
    component: view('OfficerEmployees'),
    name: 'asm.officers',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO\'s',
          active: true
        }
      ]
    }
  }
  // {
  //   path: '/asm/memos',
  //   component: view('Memo'),
  //   name: 'asm.memos',
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'ASM',
  //         to: {
  //           name: 'asm.dashboard'
  //         }
  //       },
  //       {
  //         text: 'Memos',
  //         active: true
  //       }
  //     ]
  //   }
  // }
]

const RASManagerToDos = [
  {
    path: '/asm/to-dos/activity-recordings',
    component: view('to-dos/activity-recordings/Base'),
    name: 'asm.to-dos.activity-recordings',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'Activity Recordings',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/to-dos/monthly-plans',
    component: view('to-dos/monthly-plans/Base'),
    name: 'asm.to-dos.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

const RASManagerTracking = [
  {
    path: '/asm/tasks',
    component: view('tasks/Base'),
    name: 'asm.tracking.tasks',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO Tracking'
        },
        {
          text: 'Tasks',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/tracking/officers/events',
    component: view('officers/events/Events'),
    name: 'asm.tracking.officer-events',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO Tracking'
        },
        {
          text: 'Task Events',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/tracking/officers/other-activities',
    component: view('officers/OtherEvents'),
    children: [
      {
        path: 'activities',
        component: view('officers/other-events/Base'),
        name: 'asm.tracking.officer-other-events',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      },
      {
        path: 'reports',
        component: view('reports/OtherEvents'),
        name: 'asm.reports.officer-other-events',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      }
    ]
  },
  {
    path: '/asm/tracking/officers/monthly-plans',
    component: view('officers/monthly-plans/Base'),
    name: 'asm.tracking.officer-monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO Tracking'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/tracking/customer-memos',
    component: view('customer-memos/Base'),
    children: [
      {
        path: '',
        name: 'asm.tracking.customer-memos.redirect',
        redirect: {
          name: 'asm.tracking.customer-memos.pending'
        }
      },
      {
        path: 'pending',
        component: view('customer-memos/Pending'),
        name: 'asm.tracking.customer-memos.pending',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Customer Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'processing',
        component: view('customer-memos/Processing'),
        name: 'asm.tracking.customer-memos.processing',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Customer Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'history',
        component: view('customer-memos/History'),
        name: 'asm.tracking.customer-memos.history',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Customer Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'summaries',
        component: view('customer-memos/Summaries'),
        name: 'asm.tracking.customer-memos.summaries',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Customer Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'documents',
        component: view('customer-memos/Documents'),
        name: 'asm.tracking.customer-memos.documents',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Customer Memos',
              active: true
            }
          ]
        }
      }
    ]
  },
  {
    path: '/asm/tracking/officers/:officer?',
    component: view('officers/tasks/Base'),
    children: [
      {
        path: 'tasks',
        component: view('officers/tasks/Tasks'),
        name: 'asm.tracking.officer-tasks',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Tasks',
              active: true
            }
          ]
        }
      },
      {
        path: 'tasks/:task?/events',
        component: view('officers/task-events/Base'),
        name: 'asm.tracking.officer-task-events',
        meta: {
          breadcrumb: [
            {
              text: 'ASM',
              to: {
                name: 'asm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Tasks',
              to: {
                name: 'asm.tracking.officer-tasks',
                useParameters: true
              }
            },
            {
              text: 'Events',
              active: true
            }
          ]
        }
      }
    ]
  }
]

const RASManagerReports = [
  {
    path: '/asm/reports/tasks',
    component: view('reports/Tasks'),
    name: 'asm.reports.officer-tasks',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO Reports'
        },
        {
          text: 'Tasks',
          active: true
        }
      ]
    }
  },
  {
    path: '/asm/reports/officers/monthly-plans',
    component: view('reports/MonthlyPlans'),
    name: 'asm.reports.officer-monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'ASM',
          to: {
            name: 'asm.dashboard'
          }
        },
        {
          text: 'FSO Reports'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

export default RASManager.concat(
  RASManagerToDos,
  RASManagerTracking,
  RASManagerReports
)
